export default "__VITE_ASSET__vbD211Fw__"